import apiClient from '../utils/apiClient';

/**
 * Settings Service
 * Handles all settings-related API calls
 */
const settingsService = {
  /**
   * Get all settings for the current tenant
   */
  getSettings: async () => {
    try {
      const response = await apiClient.get('/settings');
      return response.data;
    } catch (error) {
      console.error('Error fetching settings:', error);
      throw error.response?.data || error;
    }
  },

  /**
   * Update all settings
   * @param {Object} settings - Complete settings object with all categories
   */
  updateSettings: async (settings) => {
    try {
      const response = await apiClient.put('/settings', settings);
      return response.data;
    } catch (error) {
      console.error('Error updating settings:', error);
      throw error.response?.data || error;
    }
  },

  /**
   * Get specific category settings
   * @param {String} category - Category name (general, product, sales, purchase, business, personal)
   */
  getCategory: async (category) => {
    try {
      const response = await apiClient.get(`/settings/${category}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching ${category} settings:`, error);
      throw error.response?.data || error;
    }
  },

  /**
   * Update specific category settings
   * @param {String} category - Category name
   * @param {Object} data - Category settings data
   */
  updateCategory: async (category, data) => {
    try {
      const response = await apiClient.put(`/settings/${category}`, data);
      return response.data;
    } catch (error) {
      console.error(`Error updating ${category} settings:`, error);
      throw error.response?.data || error;
    }
  },

  /**
   * Reset all settings to default
   */
  resetSettings: async () => {
    try {
      const response = await apiClient.post('/settings/reset');
      return response.data;
    } catch (error) {
      console.error('Error resetting settings:', error);
      throw error.response?.data || error;
    }
  },
};

export default settingsService;
